module.exports = __webpack_public_path__ + "static/media/1005287.0b70305a.jpg";